import { render, staticRenderFns } from "./ExibirServidor.vue?vue&type=template&id=52b07274&scoped=true&"
import script from "./ExibirServidor.vue?vue&type=script&lang=js&"
export * from "./ExibirServidor.vue?vue&type=script&lang=js&"
import style0 from "./ExibirServidor.vue?vue&type=style&index=0&id=52b07274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b07274",
  null
  
)

export default component.exports